import { metrics } from '@atlassian/browser-metrics';

export const backlogEpicPanelMetric = metrics.custom({
	key: 'backlog-epic-panel-load',
});

export const setBacklogEpicPanelLoadStartMark = () => {
	backlogEpicPanelMetric.start();
};

export const setBacklogEpicPanelLoadCancelMark = () => {
	backlogEpicPanelMetric.cancel();
};

export const setBacklogEpicPanelLoadStopMark = (isCompanyManaged: boolean) => {
	backlogEpicPanelMetric.stop({
		customData: {
			isCompanyManaged,
		},
	});
};

export const BACKLOG_EPIC_PANEL_FIRST_CHUNK_END_MARK = 'FIRST_CHUNK_END_MARK';

export const epicPanelPaginationMetric = metrics.custom({
	key: 'epic-panel-pagination-load',
	histogram: {
		duration: '1000_2000_3000_4000_5000_7000_10000',
	},
	timings: [
		{
			key: 'first-chunk-load',
			endMark: BACKLOG_EPIC_PANEL_FIRST_CHUNK_END_MARK,
		},
	],
});
